import accountClient from "services/httpClient/accountClient";
import {
  VerifyIndividualProp,
  ValidateOtpProp,
  resendOTPProp,
  VerifyBusinessProp,
  CreateIndividualPayload,
  CreateBusinessPayload,
} from "pages/Auth/signup/FormModel/formModelTypes";
import { rejectFailedStatus } from "services/httpClient/rejectFailedStatus";
import {
  PredefinedQuestionsResponse,
  SaveSecurityQuestionsPayload,
  UserSecurityAnswerPayload,
  changePasswordPayload,
  UserSecurityAnswerResponse,
  InitiateResetPinResponse,
  ResetPinPayload,
  // UserSecurityQuestionResponse,
  SecurityQuestionStatusResponse,
} from "./models";
import authClient from "services/httpClient/authClient";
import vehicleClient from "services/httpClient/vehicleClients";

// Auth apis

export const verifyIndividual = (payload: VerifyIndividualProp) => {
  return vehicleClient
    .post("/api/Account/verify-individual", payload)
    .then(rejectFailedStatus);
};

export const verifyBusiness = (payload: VerifyBusinessProp) => {
  return vehicleClient
    .post("/api/Account/verify-business", payload)
    .then(rejectFailedStatus);
};

export const validateOtp = (payload: ValidateOtpProp) => {
  return vehicleClient
    .post("/api/Account/validate-otp", payload)
    .then(rejectFailedStatus);
};

export const resendOtp = (payload: resendOTPProp) => {
  return vehicleClient
    .post("/api/Account/resend-otp", payload)
    .then(rejectFailedStatus);
};

export const createIndividual = (payload: CreateIndividualPayload) => {
  return vehicleClient
    .post("/api/Account/create-individual", payload)
    .then(rejectFailedStatus);
};

export const createBusiness = (payload: CreateBusinessPayload) => {
  return vehicleClient
    .post("/api/Account/create-business", payload)
    .then(rejectFailedStatus);
};

export const acceptTerms = (payload: { termsAndConditions: boolean }) => {
  return accountClient.put("/api/User/accept-terms", payload);
}
export const getSecurityQuestions = () =>
  authClient.get<PredefinedQuestionsResponse>(
    "/api/Account/getpredefined-questions"
  );

export const getSecurityQuestionsStatus = () =>
  authClient.get<SecurityQuestionStatusResponse>("/api/Account/security-question-status");

export const saveSecurityQuestions = (payload: SaveSecurityQuestionsPayload) =>
  authClient.post("/api/Account/savesecurity-questions", payload);

export const changePassword = (payload: changePasswordPayload) =>
  authClient.post("/api/Account/change-password", payload);



export const initiateResetPin = () =>
  authClient.post<InitiateResetPinResponse>("/api/Account/initiate-reset-pin");

export const resetPin = (payload: ResetPinPayload) =>
  authClient.post("/api/Account/reset-pin", payload);

export const changePin = (payload: {
  NewPin: string,
  OldPin: string,
  ConfirmNewPin: string
}) =>
  authClient.post("/api/Account/change-pin", payload);

export const userSecurityQuestion = () =>
  authClient.get<any>(
    "/api/Account/user-security-question");

export const userSecurityAnswer = (payload: UserSecurityAnswerPayload) =>
  authClient.post(
    "/api/Account/user-security-answer", {
    ...payload,
    CreatedBy: "string",
    CreatedOn: "2024-06-11T12:51:27.801Z",
    UpdatedBy: "string",
    UpdatedOn: "2024-06-11T12:51:27.801Z",
    ApprovedBy: "string",
    ApprovedOn: "2024-06-11T12:51:27.801Z",
  });

export const validatePin = (payload: { Pin: string }) => authClient.post(
  '/api/Account/validate-pin',
  payload
)


export const setUpSecurityQuestion = async (body: any) => authClient.post(
  '/api/Account/savesecurity-questions',
  body
)